import axios from 'axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  REQUEST(state, request) {
    state.cached = request
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchAttendances(context, query) {
    query = query || ''
    return axios.get(`http://localhost:3000/attendances/${query}`).then((response) => {
      // const request = response.data
      // context.commit('REQUEST', request)
      return {
        "count": 12,
        "next": "http://localhost:3000/attendances/?_page=2",
        "previous": null,
        "results": response.data
      }
    })
  },

  // fetchRequestOptions(context, query) {
  //   query = query || ''
  //   return axios.get(`${serverUrl}/api/requests/options/${query}`).then((response) => {
  //     return response.data
  //   })
  // },

  // fetchRequestDetail(context, id) {
  //   return axios.get(`${serverUrl}/api/requests/${id}/`).then((response) => {
  //     return response.data
  //   })
  // },

  // createUpdateRequest(context, formData) {
  //   let promise = null
  //   if (formData.url){
  //     promise =  axios.put(formData.url, formData)
  //   }else {
  //     promise =  axios.post(`${serverUrl}/api/requests/`, formData)
  //   }
  //   return promise.then(
  //     (response) => {
  //       return response.data
  //     }
  //   )
  // },
  // deleteRequest(context, permUrl) {
  //   let promise = null
  //   promise =  axios.delete(permUrl)
  //   return promise.then(
  //     (response) => {
  //       return response.data
  //     }
  //   )
  // },
}